export default __webpack_public_path__ + "static/media/wifi.3e039454.svg";